export default {
  SnakegameTitle: 'Snake Game Settings',
  topic: 'Topic (Game Activity Name)',
  inputTopic: 'Enter game topic name',
  correctItems: 'Correct Items',
  correctItemsPlaceholder: 'Enter correct words, separated by line breaks or commas (,), press Enter to add',
  errorItems: 'Error Items',
  errorItemsPlaceholder: 'Enter wrong words, separated by line breaks or commas (,), press Enter to add',
  difficulty: 'Difficulty Level',
  difficultyEasy: 'Easy',
  difficultyMedium: 'Medium',
  difficultyHard: 'Hard',
  boardSize: 'Board Size',
  snakeSpeed: 'Snake Speed',
  foodCount: 'Food Count',
  items: 'items',
  gameDuration: 'Game Duration',
  second: 'seconds',
  clearData: 'Clear Data',
  saveSettings: 'Save Settings',
  wordExists: 'This word already exists',
  maxVocabulary: 'Maximum correct words reached (20)',
  maxErrorVocabulary: 'Maximum wrong words reached (20)',
  dataCleared: 'Data cleared',
  settingsSaved: 'Settings saved',
  pleaseCompleteSettings: 'Please complete all required fields (at least 5 correct words and 5 wrong words)',
  unsubmittedWarning: 'Unsubmitted words found in the input field. Please confirm and press Enter before proceeding!',
  gamePaused: 'Game Paused',
  gameOver: 'Game Over',
  showAnswers: 'Show Answers',
  referenceAnswers: 'Reference Answers',
  maxLength: 'Max Length',
  leftPlayer: 'Left Player',
  rightPlayer: 'Right Player',
  sendSuccess: 'Game data has been successfully pushed!',
  sendCooldown: 'Already sent, please wait 1 minute before trying again',
  pushSuccess: 'Game short URL has been successfully pushed!',
  pushFailed: 'Push failed: {message}',
  tokenRefreshing: 'Refreshing authorization, please try again later...',

  // Small screen warning
  smallScreenWarning: 'This game is designed for desktop use. Recommended for computer or tablet with minimum screen width of 1200px*800px',
  currentRank: 'Current Rank',
  totalParticipants: 'Total Participants',
};
